import { TextService } from "../Services/TextService";
import { MemberFieldTypes } from "../Types/MemberFieldTypes"

export const mapDynamicRequiredMessage = (type: MemberFieldTypes) => {
    const GetText = TextService.GetText;

    return GetText("EditMember_Mandatory");
}